import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import axios from 'axios'
import { userKey, urlApi } from '@/config/global'

import Home from '../views/Home'
import Login from '../views/Login'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        
        {
            path: '/',
            component: Login,
            name: 'Login',
            meta: { authenticated: false, styles: '' },
        },

        {
            path: '/Home',
            component: Home,
            name: 'Home',
            meta: { authenticated: true, styles: '' },
        },
        
        // redirect
        {
            path: '/redirect',
            redirect: '/'
        },
        // 404
        {
            path: '*',
            redirect: '/'
        }
    ]
})

router.beforeEach((to, from, next) => {
    // removendo css do login
    let elm = document.getElementById("login-style");
    if (to.name != 'Login') {
        if (elm) {
            elm.remove();
        }
    } else {        
        if (!elm) {
            let style = document.createElement('link');
            style.id = "login-style";
            style.type = "text/css";
            style.rel = "stylesheet";
            style.href = '/assets/css/login.css';
            document.head.appendChild(style);
        }
    }

    if (to.matched.some(record => record.meta.authenticated)) {
        // rota logado
        let user = store.getters.getUser

        if (!user) {
            // deslogado
            const json = localStorage.getItem(userKey)
            const userData = JSON.parse(json)

            const req = async () => {
                try {
                    const res = await axios.post(`${urlApi}/Auth/refresh`, userData)
                    if (res.data) {
                        if (res.data.token.authenticated) {
                            res.data.token.usuario = res.data.usuario;
                            res.data.token.usuario.idContrato = res.data.idContrato;
                            res.data.token.usuario.tpPessoa = res.data.tpPessoa;
                            res.data.token.usuario.flCortesia = res.data.flCortesia;
                            res.data.token.usuario.isAdmContrato = res.data.isAdmContrato;

                            store.commit('setUser', res.data.token)
                            if (to.meta.styles) {
                                // Carregue dinamicamente os estilos
                                import(`@/assets/css/${to.meta.styles}.css`)
                                    .then(() => {
                                        next()
                                    })
                                    .catch(() => {
                                        next() // Se houver um erro no carregamento, prossiga mesmo assim
                                    })
                            } else {
                                next()
                            }
                        } else {
                            store.commit('setUser', null);
                            next({ name: 'Login' });
                        }
                    } else {
                        next({ name: 'Login' });
                    }
                } catch (err) {
                    next({ name: 'Login' });
                }
            };

            req();

        } else {
            // logado
            if (user.authenticated) {
                if (to.meta.styles) {
                    // Carregue dinamicamente os estilos
                    import(`@/assets/css/${to.meta.styles}.css`)
                        .then(() => {
                            next()
                        })
                        .catch(() => {
                            next() // Se houver um erro no carregamento, prossiga mesmo assim
                        })
                } else {
                    next()
                }
            }else {
                next(false)
            }
        }

    } else {
        // rota deslogado
        if (to.meta.styles) {
            // Carregue dinamicamente os estilos
            import(`@/assets/css/${to.meta.styles}.css`)
                .then(() => {
                    next()
                })
                .catch(() => {
                    next() // Se houver um erro no carregamento, prossiga mesmo assim
                })
        } else {
            next()
        }
    }
})

export default router